import { createRouter, createWebHistory } from 'vue-router'
import NotFoundView from '../views/NotFoundView.vue'
import PalworldEulaView from '../views/PalworldEulaView.vue'
import PalworldModGuidelineView from '../views/PalworldModGuidelineView.vue'

const routes = [
  {
    path: '/palworld',
    name: 'palworldEula',
    component: PalworldEulaView
  },
  {
    path: '/palworld-mod-guideline',
    name: 'palworldModGuideline',
    component: PalworldModGuidelineView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundView',
    component: NotFoundView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
